import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import DesktopPopUp from "./DesktopPopUp";
import styles from "./bookingPopUpDesktop.module.css";
import { go } from "../../routes";
import { clearAppointmentData, findDoctor } from "../../selectors/appointmentSelectors";
import { doctorProfilePropType } from "../propTypes/index"

const BookingPopUpDesktop = ({ practiceName, doctor, appointment, match, clearAppointment }) => (
  <div className={styles.container}>
    <DesktopPopUp
      closePopUp={() => go.practiceProfile(match.params.orgId)}
      clearAppointment={clearAppointment}
      doctor={doctor}
      practiceName={practiceName}
      appointment={appointment}
      match={match}
      goBack={() => go.patientSelection(match.params.orgId)}
      hideBack={true}
      outside={true}
    />
  </div>
);

BookingPopUpDesktop.propTypes = {
  doctor: doctorProfilePropType.isRequired,
  practiceName: PropTypes.string.isRequired,
  appointment: PropTypes.string.isRequired,
  clearAppointment: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  practiceName: state.practiceProfileReducer.profile.Name,
  appointment: state.practiceAppointmentReducer.selectedTime.time,
  doctor: findDoctor(
    state.practiceAppointmentReducer.selectedTime.doctorId,
    state.practiceProfileReducer.profile.Doctors,
  ),
});

const mapDispatchToProp = dispatch => ({
  clearAppointment: clearAppointmentData(dispatch),
});

export default connect(mapStateToProps, mapDispatchToProp)(BookingPopUpDesktop);
